module.exports = __webpack_public_path__ + "assets/favicons/favicon-16x16.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/favicon-16x16.png
// module id = 1236
// module chunks = 1